import { cn } from '@seen/ui'
import { IconClipboardPlus } from '@tabler/icons-react'

export function IconCondition({ className }: { className?: string }) {
  return <IconClipboardPlus className={cn('size-4 shrink-0', className)} />
}
